import React from 'react'
import "./LinkBtn.css"

const LinkBtn = ({ link, titleLink }) => {
    return (
        <div className='link-btn-container'>
            <a className='link-btn-title' href={`${link}`}>{titleLink}</a>
        </div>
    )
}

export default LinkBtn
